import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';

interface AutomationRule {
  id: string;
  nome: string;
  ativa: boolean;
  gatilho: string;
  acao: string;
  prioridade: number;
}

export function ChatAutomationRulesPanel() {
  const [rules, setRules] = useState<AutomationRule[]>([]);
  const [loading, setLoading] = useState(false);

  const load = () => {
    setLoading(true);
    api.get('/chat-interno/automacoes/regras')
      .then((res) => setRules(res.data || []))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const toggle = async (rule: AutomationRule) => {
    await api.patch(`/chat-interno/automacoes/regras/${rule.id}`, { ativa: !rule.ativa });
    load();
  };

  if (loading && !rules.length) return <div className="p-4 text-sm text-muted-foreground">Carregando regras...</div>;

  return (
    <div className="grid gap-3">
      {rules.map((rule) => (
        <div key={rule.id} className="rounded-xl border bg-card p-4 shadow-sm">
          <div className="flex items-center justify-between gap-3">
            <div>
              <h3 className="text-sm font-black">{rule.nome}</h3>
              <p className="mt-1 text-xs text-muted-foreground">{rule.gatilho} → {rule.acao}</p>
            </div>
            <button type="button" className="btn-save" onClick={() => toggle(rule)}>
              {rule.ativa ? 'Ativa' : 'Inativa'}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
